/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateTunneledMcpServerForm,
  UpdateTunneledMcpServerForm$Outbound,
  UpdateTunneledMcpServerForm$outboundSchema,
} from "../components/updatetunneledmcpserverform.js";

export type UpdateTunneledMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateTunneledMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateTunneledMcpServerSecurity = {
  option1?: UpdateTunneledMcpServerSecurityOption1 | undefined;
  option2?: UpdateTunneledMcpServerSecurityOption2 | undefined;
};

export type UpdateTunneledMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateTunneledMcpServerForm: UpdateTunneledMcpServerForm;
};

/** @internal */
export type UpdateTunneledMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateTunneledMcpServerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    UpdateTunneledMcpServerSecurityOption1$Outbound,
    UpdateTunneledMcpServerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateTunneledMcpServerSecurityOption1ToJSON(
  updateTunneledMcpServerSecurityOption1:
    UpdateTunneledMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    UpdateTunneledMcpServerSecurityOption1$outboundSchema.parse(
      updateTunneledMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateTunneledMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateTunneledMcpServerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    UpdateTunneledMcpServerSecurityOption2$Outbound,
    UpdateTunneledMcpServerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function updateTunneledMcpServerSecurityOption2ToJSON(
  updateTunneledMcpServerSecurityOption2:
    UpdateTunneledMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    UpdateTunneledMcpServerSecurityOption2$outboundSchema.parse(
      updateTunneledMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateTunneledMcpServerSecurity$Outbound = {
  Option1?: UpdateTunneledMcpServerSecurityOption1$Outbound | undefined;
  Option2?: UpdateTunneledMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateTunneledMcpServerSecurity$outboundSchema: z.ZodMiniType<
  UpdateTunneledMcpServerSecurity$Outbound,
  UpdateTunneledMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateTunneledMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateTunneledMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateTunneledMcpServerSecurityToJSON(
  updateTunneledMcpServerSecurity: UpdateTunneledMcpServerSecurity,
): string {
  return JSON.stringify(
    UpdateTunneledMcpServerSecurity$outboundSchema.parse(
      updateTunneledMcpServerSecurity,
    ),
  );
}

/** @internal */
export type UpdateTunneledMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateTunneledMcpServerForm: UpdateTunneledMcpServerForm$Outbound;
};

/** @internal */
export const UpdateTunneledMcpServerRequest$outboundSchema: z.ZodMiniType<
  UpdateTunneledMcpServerRequest$Outbound,
  UpdateTunneledMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateTunneledMcpServerForm: UpdateTunneledMcpServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateTunneledMcpServerForm: "UpdateTunneledMcpServerForm",
    });
  }),
);

export function updateTunneledMcpServerRequestToJSON(
  updateTunneledMcpServerRequest: UpdateTunneledMcpServerRequest,
): string {
  return JSON.stringify(
    UpdateTunneledMcpServerRequest$outboundSchema.parse(
      updateTunneledMcpServerRequest,
    ),
  );
}
